import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import GlobalStyles from "./Services/Restore/assets/styles/globalStyle";
import { store } from "./Services/Restore/redux/store";
import Boot from "./Services/Restore/redux/boot";
import AppRouter from "./router";
import { ErrorBoundary } from "./ErrorBoundary";
import { AbilityProvider } from "./Services/common/casl/AbilityContext";
import AppProvider from "./AppProvider";

const App = () => {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <AbilityProvider>
            <AppProvider>
              <GlobalStyles />
              <AppRouter />
            </AppProvider>
          </AbilityProvider>
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  );
};

const BootstrappedApp = Boot(App);
export default BootstrappedApp;
